import { createContext, useState, useMemo } from "react";
export const ContentContext = createContext({data : []});

export default function ContentProvider(props){
    const [namespaces, setNamespaces] = useState([]);
    const [clientName, setClientName] = useState([]);

    const providerValue = useMemo(() => ({namespaces, setNamespaces, clientName, setClientName}));

    return (
        <ContentContext.Provider value={providerValue}>
            {props.children}
        </ContentContext.Provider>
    );
}